export default __webpack_public_path__ + "static/media/profileIcon.70f9c678.svg";